import { useState, useEffect } from 'react';
import { JobsComponent, configureJobsAuth, authEvents } from '@umd-dit/jobs-component-react';
import '@umd-dit/jobs-component-react/style.css';
import { addAuthHeaders } from '@umd-dit/oidc-core';

export default function Jobs() {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  // Configure the jobs component with the addAuthHeaders from OIDC core
  useEffect(() => {
    try {
      // Check if addAuthHeaders is available
      if (typeof addAuthHeaders !== 'function') {
        throw new Error('addAuthHeaders from OIDC core is not available');
      }

      // Pass the addAuthHeaders function to the job component
      configureJobsAuth(addAuthHeaders);
      console.log('Jobs component configured with legislative-review auth mechanism');

      // Subscribe to auth error events from the job component
      const unsubscribe = authEvents.onAuthError((event) => {
        console.warn('Auth error received in parent component:', event);
        // You could redirect to login page or trigger OIDC re-authentication here
      });

      // Clean up the subscription when component unmounts
      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error('Error configuring jobs auth:', error);
      // Display an error message to the user
      alert('Failed to initialize jobs component. Authentication configuration error.');
    }
  }, []); // No dependencies since addAuthHeaders is imported directly

  return (
    <div className="container mx-auto px-4 py-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-2">
          <span className="text-sm">Theme:</span>
          <button
            onClick={() => setTheme('light')}
            className={`px-3 py-1 rounded-md text-sm ${theme === 'light' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
          >
            Light
          </button>
          <button
            onClick={() => setTheme('dark')}
            className={`px-3 py-1 rounded-md text-sm ${theme === 'dark' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
          >
            Dark
          </button>
        </div>
      </div>

      {/* React component instead of web component */}
      <JobsComponent
        appId="legislative-review"
        viewType="summary"
        timePeriod="monthly"
        theme={theme}
        jobsApiUrl={import.meta.env.VITE_JOBS_API_URL}
      />
    </div>
  );
}